export default __webpack_public_path__ + "static/media/IICT-Building.bd4670de.jpg";